import { CellId, ExploreSpec } from "@hex/common";
import { shallowEqual } from "react-redux";

import {
  useCellContentsGetter,
  useCellContentsSelector,
} from "../../hex-version-multiplayer/state-hooks/cellContentsStateHooks.js";
import { CellContentsMP } from "../../redux/slices/hexVersionMPSlice.js";

export function useExploreSpecSelector<T>(
  cellId: CellId,
  selector: (spec: ExploreSpec) => T,
): T {
  return useCellContentsSelector({
    cellId,
    selector: (contents) => {
      if (contents.__typename !== "ExploreCell") {
        throw new Error(`Expected ExploreCell, got ${contents.__typename}`);
      }
      return selector(contents.spec);
    },
    equalityFn: shallowEqual,
  });
}

export function useSafeExploreSpecSelector<T>(
  cellId: CellId | undefined,
  selector: (spec: ExploreSpec) => T | undefined,
): T | undefined {
  return useCellContentsSelector({
    cellId,
    selector: (contents: CellContentsMP | undefined) => {
      if (contents?.__typename !== "ExploreCell") {
        return undefined;
      }
      return selector(contents.spec);
    },
    equalityFn: shallowEqual,
    safe: true,
  });
}

export function useExploreSpecGetter<T>(
  selector: (spec: ExploreSpec) => T,
): (cellId: CellId) => T {
  return useCellContentsGetter({
    selector: (contents) => {
      if (contents.__typename !== "ExploreCell") {
        throw new Error(`Expected ExploreCell, got ${contents.__typename}`);
      }
      return selector(contents.spec);
    },
  });
}
